import { useEffect, useState } from 'react';
import { SecurityFormData } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/Securities/types.ts';
import { AdvancedSwitch } from '@dealstack/frontend/shared/components/Switch/AdvancedSwitch.tsx';

interface Props {
	security: SecurityFormData;
	onToggle: (security: SecurityFormData) => void;
}

export const VestingToggleCell = ({ security, onToggle }: Props) => {
	// Local mirror of the server value. The update is not optimistic at the API
	// layer, so without this the switch sits still until the mutation + refetch
	// resolves (and then jumps). Flipping local state on click makes it animate
	// immediately; the effect re-syncs to the server value once it settles.
	const [checked, setChecked] = useState(security.isSubjectToVesting);

	useEffect(() => {
		setChecked(security.isSubjectToVesting);
	}, [security.isSubjectToVesting]);

	return (
		<AdvancedSwitch
			selectedValue={checked}
			onChange={() => {
				setChecked((prev) => !prev);
				onToggle(security);
			}}
		/>
	);
};
